import { SvgIcon, SvgIconProps } from '@mui/material';

export const FeedIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 17 21" {...props}>
      <svg
        width="17"
        height="21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M14.9884 0H2.55427C1.69942 0 1.00777 0.69942 1.00777 1.55427L1 15.5427L4.10853 12.4341H14.9884C15.8432 12.4341 16.5427 11.7347 16.5427 10.8799V1.55427C16.5427 0.69942 15.8432 0 14.9884 0ZM4.88566 5.43993H12.657C13.0844 5.43993 13.4341 5.78964 13.4341 6.21706C13.4341 6.64449 13.0844 6.9942 12.657 6.9942H4.88566C4.45824 6.9942 4.10853 6.64449 4.10853 6.21706C4.10853 5.78964 4.45824 5.43993 4.88566 5.43993ZM9.54846 9.32559H4.88566C4.45824 9.32559 4.10853 8.97588 4.10853 8.54846C4.10853 8.12104 4.45824 7.77133 4.88566 7.77133H9.54846C9.97588 7.77133 10.3256 8.12104 10.3256 8.54846C10.3256 8.97588 9.97588 9.32559 9.54846 9.32559ZM12.657 4.6628H4.88566C4.45824 4.6628 4.10853 4.31309 4.10853 3.88566C4.10853 3.45824 4.45824 3.10853 4.88566 3.10853H12.657C13.0844 3.10853 13.4341 3.45824 13.4341 3.88566C13.4341 4.31309 13.0844 4.6628 12.657 4.6628Z"
          fill="currentColor"
        />
        <path
          d="M1 17.5L4.5 14H13.882C14.6172 14 15.3424 13.8288 16 13.5V13.5"
          stroke="currentColor"
        />
        <path
          d="M1 20L5 16H13.4848C14.3479 16 15.2025 15.8301 16 15.5V15.5"
          stroke="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
